import mobileLeftImage from '../../../images/characters-banner/characters-mobile-left.png';
import mobileRightImage from '../../../images/characters-banner/characters-mobile-right.png';
import desktopLeftImage from '../../../images/characters-banner/characters-desktop-left.png';
import desktopRightImage from '../../../images/characters-banner/characters-desktop-right.png';

import { Banner } from '../Banner';

const STORAGE_KEY = 'charactersBannerClosed';

type CharactersBannerProps = {
    onClick?: () => void;
};

export const CharactersBanner = ({ onClick }: CharactersBannerProps) => (
    <Banner
        storageKey={STORAGE_KEY}
        text="Попробуйте новых персонажей и общайтесь с ними в Алисе"
        buttonText="Смотреть"
        onClick={onClick}
        images={{
            mobileLeft: mobileLeftImage,
            mobileRight: mobileRightImage,
            desktopLeft: desktopLeftImage,
            desktopRight: desktopRightImage,
        }}
    />
);
